module.exports = __webpack_public_path__ + "static/media/guy.e547c78f.png";